module.exports = __webpack_public_path__ + "static/media/banner_reservar.99ad988c.jpg";